import script from "./OutboundOrderTpl.vue?vue&type=script&setup=true&lang=js"
export * from "./OutboundOrderTpl.vue?vue&type=script&setup=true&lang=js"

import "./OutboundOrderTpl.vue?vue&type=style&index=0&id=b319afac&scoped=true&lang=css"
import "./OutboundOrderTpl.vue?vue&type=style&index=1&id=b319afac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b319afac"]])

export default __exports__